// screen orientation
export const LANDSCAPE = 'landscape';
export const PORTRAIT = 'portrait';

export const MENUBAR_WIDTH = 76;
export const CONTAINER_WIDTH_DESKTOP = 1360;
export const CONTAINER_WIDTH_TABLET = 950;
export const CANVAS_WIDTH_DESKTOP = CONTAINER_WIDTH_DESKTOP - MENUBAR_WIDTH;
export const CANVAS_WIDTH_TABLET = CONTAINER_WIDTH_TABLET - MENUBAR_WIDTH;

export const EMAIL = 'email';
export const FACEBOOK = 'facebook';
export const PINTEREST = 'pinterest';
export const SMS = 'sms';

export const noop = () => {};
